import enUs from "./texts/en-us";
import ptBr from "./texts/pt-br";

const texts = {
  pt: ptBr,
  en: enUs,
};

export default texts;
